var id = {
	"neptune.Button.loadingAriaLabel": "memuat",
	"neptune.Chips.ariaLabel": "Hapus {choice}",
	"neptune.ClearButton.ariaLabel": "Hapus",
	"neptune.CloseButton.ariaLabel": "Tutup",
	"neptune.DateInput.day.label": "Hari",
	"neptune.DateInput.day.placeholder": "HH",
	"neptune.DateInput.month.label": "Bulan",
	"neptune.DateInput.year.label": "Tahun",
	"neptune.DateInput.year.placeholder": "TTTT",
	"neptune.DateLookup.day": "hari",
	"neptune.DateLookup.goTo20YearView": "Lihat tampilan 20 tahun",
	"neptune.DateLookup.month": "bulan",
	"neptune.DateLookup.next": "berikutnya",
	"neptune.DateLookup.previous": "sebelumnya",
	"neptune.DateLookup.selected": "terpilih",
	"neptune.DateLookup.twentyYears": "20 tahun",
	"neptune.DateLookup.year": "tahun",
	"neptune.FlowNavigation.back": "kembali ke langkah sebelumnya",
	"neptune.Info.ariaLabel": "Informasi lebih lanjut",
	"neptune.Label.optional": "(Opsional)",
	"neptune.Link.opensInNewTab": "(terbuka di tab baru)",
	"neptune.MoneyInput.Select.placeholder": "Pilih opsi...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Pilih mata uang",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Pilih opsi...",
	"neptune.Select.searchPlaceholder": "Cari...",
	"neptune.SelectInput.noResultsFound": "Hasil tidak ditemukan",
	"neptune.SelectOption.action.label": "Pilih",
	"neptune.SelectOption.selected.action.label": "Ubah opsi yang dipilih",
	"neptune.StatusIcon.iconLabel.error": "Kesalahan:",
	"neptune.StatusIcon.iconLabel.information": "Informasi:",
	"neptune.StatusIcon.iconLabel.pending": "Tertunda:",
	"neptune.StatusIcon.iconLabel.success": "Berhasil:",
	"neptune.StatusIcon.iconLabel.warning": "Peringatan:",
	"neptune.Summary.statusDone": "Item selesai",
	"neptune.Summary.statusNotDone": "Item yang harus dilakukan",
	"neptune.Summary.statusPending": "Item tertunda",
	"neptune.Table.actionHeader": "Tindakan",
	"neptune.Table.emptyData": "Hasil tidak ditemukan",
	"neptune.Table.loaded": "Data tabel telah dimuat",
	"neptune.Table.loading": "Data tabel sedang dimuat",
	"neptune.Table.refreshPage": "Muat ulang halaman",
	"neptune.Upload.csButtonText": "Unggah file lainnya?",
	"neptune.Upload.csFailureText": "Unggahan gagal. Silakan coba lagi",
	"neptune.Upload.csSuccessText": "Pengunggahan selesai!",
	"neptune.Upload.csTooLargeMessage": "Harap berikan file yang lebih kecil dari {maxSize} MB",
	"neptune.Upload.csWrongTypeMessage": "Tipe file ini tidak didukung. Mohon coba lagi dengan file yang berbeda",
	"neptune.Upload.psButtonText": "Batalkan",
	"neptune.Upload.psProcessingText": "Mengunggah...",
	"neptune.Upload.retry": "Coba lagi",
	"neptune.Upload.usButtonText": "Atau pilih file",
	"neptune.Upload.usDropMessage": "Letakkan file untuk mulai mengunggah",
	"neptune.Upload.usPlaceholder": "Seret dan lepas file yang kurang dari {maxSize} MB",
	"neptune.UploadButton.allFileTypes": "Semua jenis file",
	"neptune.UploadButton.dropFiles": "Lepaskan file untuk mulai mengunggah",
	"neptune.UploadButton.instructions": "{fileTypes}, kurang dari {size}MB",
	"neptune.UploadButton.maximumFiles": "Maksimal {maxFiles} file.",
	"neptune.UploadButton.uploadFile": "Unggah file",
	"neptune.UploadButton.uploadFiles": "Unggah file",
	"neptune.UploadInput.deleteModalBody": "Menghapus file ini akan menghilangkannya dari sistem kami.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Batalkan",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Hapus",
	"neptune.UploadInput.deleteModalTitle": "Yakin ingin menghapus file ini?",
	"neptune.UploadInput.fileIsTooLarge": "File terlalu besar",
	"neptune.UploadInput.fileTypeNotSupported": "Jenis file tidak didukung",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Maaf, unggahan ini gagal karena kami hanya dapat menerima {maxFilesAllowed} file sekaligus.",
	"neptune.UploadItem.deleting": "Menghapus...",
	"neptune.UploadItem.removeFile": "Hapus file {filename}",
	"neptune.UploadItem.uploaded": "Diunggah",
	"neptune.UploadItem.uploadedFile": "File yang diunggah",
	"neptune.UploadItem.uploading": "Mengunggah...",
	"neptune.UploadItem.uploadingFailed": "Pengunggahan gagal"
};

export { id as default };
//# sourceMappingURL=id.json.mjs.map
